export enum EfficienyType {
    Working = 0,
    Movement,
    Usage,
    Load,
    Comparing
}